export default __webpack_public_path__ + "static/media/8.ab95c7cb.png";